import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_marker = _resolveComponent("l-marker")!
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_map = _resolveComponent("l-map")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_l_map, {
      zoom: _ctx.zoom,
      center: _ctx.center,
      style: {"height":"200px","width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_l_marker, {
          "lat-lng": _ctx.center,
          icon: _ctx.customIcon
        }, null, 8, ["lat-lng", "icon"]),
        _createVNode(_component_l_tile_layer, {
          url: _ctx.url,
          attribution: _ctx.attribution
        }, null, 8, ["url", "attribution"])
      ]),
      _: 1
    }, 8, ["zoom", "center"])
  ]))
}